import { Component, computed, inject, input, InputSignal, OnInit, output, Signal, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MDIconComponent, MDTagComponent } from '@melodic-ui/components';
import { AuthenticationService } from '../../auth/services/authentication.service';
import { BetaTagComponent } from '../beta-tag/beta-tag.component';

export type NavigationItem = {
	linkText: string;
	linkIcon: string;
	href?: string;
	target?: string;
	routerLink?: string;
	exact?: boolean;
	action?: () => void;
	childNav?: NavigationItem[];
	isBeta?: boolean;
	/**
	 * Optional count shown beside the label — outstanding work behind this item.
	 *
	 * Zero and undefined both render nothing: a badge showing "0" is a claim that there is something
	 * to look at, which is the opposite of what an empty queue means.
	 */
	badgeCount?: number;
};

type InternalNavigationItem = NavigationItem & {
	active?: boolean;
};

// NOTE: NavigationComponent
// This component must be used within the ApplicationContainerComponent

@Component({
	selector: 'lb-navigation',
	standalone: true,
	imports: [CommonModule, RouterModule, MDIconComponent, MDTagComponent, BetaTagComponent],
	templateUrl: './navigation.component.html',
	styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit {
	private _authenticationService: AuthenticationService = inject(AuthenticationService);
	private _isAuthenticated: WritableSignal<boolean> = signal<boolean>(false);

	public navigationItems: InputSignal<NavigationItem[]> = input<NavigationItem[]>([]);
	public bottomNavigationItems: InputSignal<NavigationItem[]> = input<NavigationItem[]>([]);
	public expanded: InputSignal<boolean> = input<boolean>(true);
	public disabled: InputSignal<boolean> = input<boolean>(false);
	public expandToggled = output<void>();

	public internalNavigationItems: Signal<InternalNavigationItem[]> = computed(() => {
		return [...this.navigationItems().map((item) => ({ ...item, active: false }))] as InternalNavigationItem[];
	});

	public internalBottomNavigationItems: Signal<InternalNavigationItem[]> = computed(() => {
		const bottomNavItems: InternalNavigationItem[] = [...this.bottomNavigationItems().map((item) => ({ ...item, active: false }))];

		// if (this._isAuthenticated()) {
		// 	bottomNavItems.push({
		// 		linkText: 'Log Out',
		// 		linkIcon: 'untitled-ui/general/log-out-01',
		// 		action: () => this._authenticationService.signOut(),
		// 		active: false
		// 	});
		// }

		return bottomNavItems;
	});

	async ngOnInit(): Promise<void> {
		const isAuthenticated = await this._authenticationService.isAuthenticated();
		this._isAuthenticated.set(isAuthenticated);
	}

	public onToggleClick(event: MouseEvent): void {
		event.stopPropagation();
		this.expandToggled.emit();
	}
}
